import React, { useEffect, useState, useContext } from 'react';
import {
  Box, Typography, Grid, Chip, Card, CardContent, IconButton, Paper, Container,Button ,CircularProgress,
} from '@mui/material';
import { useLocation, useNavigate, useParams } from 'react-router-dom'; // ADDED useParams
import axios from 'axios';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import BedIcon from '@mui/icons-material/Bed';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ElevatorIcon from '@mui/icons-material/Elevator';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import BalconyIcon from '@mui/icons-material/Balcony';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import OpacityIcon from '@mui/icons-material/Opacity';
import CropSquareOutlinedIcon from '@mui/icons-material/CropSquareOutlined';
import CompassCalibrationOutlinedIcon from '@mui/icons-material/CompassCalibrationOutlined';
import LayersOutlinedIcon from '@mui/icons-material/LayersOutlined';
import SecurityOutlinedIcon from '@mui/icons-material/SecurityOutlined';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import buildingImage from './../../../Images/house.jpeg';
import CustomBottomNav from './CustomBottomNav';
import { BASE_URL } from './../../Api/ApiUrls';
import { AuthContext } from './../../AuthContext/AuthContext';
import CallIcon from '@mui/icons-material/Call';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Tooltip } from '@mui/material';
import CopyFailureAlert from '../Alertpage/CopyAlert/CopyFailureAlert';
import CopySuccessAlert from '../Alertpage/CopyAlert/CopySuccessAlert';


const NewBuildingsDescription = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { propertyId: paramPropertyId } = useParams(); // ADDED: Get from URL params
  const { userId, logout } = useContext(AuthContext);
  console.log("userID",userId)
  // CHANGED: Get propertyId from both state AND URL params
  const { propertyId: statePropertyId } = location.state || {};
  const propertyId = statePropertyId || paramPropertyId; // Use either one
  const [loadingLocation, setLoadingLocation] = useState(false);

  const [categories, setCategories] = useState([]);
  const [property, setProperty] = useState(null);
  const [selectedImage, setSelectedImage] = useState(0);
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [showSubscribeModal, setShowSubscribeModal] = useState(false);
  const [featureRequested, setFeatureRequested] = useState('');
  const [userPlan, setUserPlan] = useState(null);
  const [userActivities, setUserActivities] = useState([]);
  const [showLimitModal, setShowLimitModal] = useState(false);
const [showSuccess, setShowSuccess] = useState(false);
const [showFailure, setShowFailure] = useState(false);
const [alertMessage, setAlertMessage] = useState("");

const handleCopyMobile = (mobile) => {
  if (!mobile || mobile.trim() === '') {
    setAlertMessage("Mobile number not available");
    setShowFailure(true);
    return; 
  }

  navigator.clipboard.writeText(mobile)
    .then(() => {
      setAlertMessage(`Mobile number copied: ${mobile}`);
      setShowSuccess(true);
    })
    .catch((err) => {
      console.error("Copy failed:", err);
      setAlertMessage("Failed to copy mobile number");
      setShowFailure(true);
    });
};

const formatPrice = (price) => {
  if (!price) return 'NA';

  if (price >= 10000000) {
    return `${(price / 10000000).toFixed(1).replace(/\.0$/, '')} Cr`;
  }
  if (price >= 1000000) {
    return `${(price / 1000000).toFixed(1).replace(/\.0$/, '')} M`;
  }
  if (price >= 100000) {
    return `${(price / 100000).toFixed(1).replace(/\.0$/, '')} L`;
  }
  if (price >= 1000) {
    return `${(price / 1000).toFixed(1).replace(/\.0$/, '')} K`;
  }

  return price.toString();
};


  const handleImageClick = (image) => {
    setSelectedImage(image);
  };

  // ADDED: Debug logging to see what's happening
  console.log('Location state:', location.state);
  console.log('URL params propertyId:', paramPropertyId);
  console.log('Final propertyId:', propertyId);

  useEffect(() => {
   const checkSubscription = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/Get-user-plan/${userId}/`);
      const userSubscriptions = response.data;
      const hasBuyerSubscription = Array.isArray(userSubscriptions) &&
        userSubscriptions.some(sub => sub.user_type === "Buyer");
      setIsSubscribed(hasBuyerSubscription);
    } catch (error) {
      console.error('Error checking subscription:', error);
      setIsSubscribed(false);
    }
  };

    if (userId) {
      checkSubscription();
    } else {
      console.log('No user ID, defaulting to non-subscribed state');
      setIsSubscribed(false);
      setUserPlan(null);
    }
  }, [userId]);

  useEffect(() => {
    const fetchUserActivities = async () => {
      if (!userId) {
        console.log('No userId - skipping activity fetch');
        return;
      }
      
      try {
        console.log(`Fetching activities for user ${userId}`);
        const response = await fetch(`${BASE_URL}/activities/`);
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const allActivities = await response.json();
        console.log('All activities from API:', allActivities);
        
        const filteredActivities = allActivities.filter(activity => 
          activity && activity.user_id !== undefined && 
          String(activity.user_id) === String(userId)
        );
        
        console.log('Filtered user activities:', filteredActivities);
        setUserActivities(filteredActivities);
      } catch (error) {
        console.error('Error fetching activities:', error);
        setUserActivities([]);
      }
    };

    fetchUserActivities();
  }, [userId]);

  const checkPropertyLimit = (currentPropertyId) => {
    if (!isSubscribed) {
      console.log('Non-subscriber - access denied');
      setFeatureRequested("Property Access");
      setShowSubscribeModal(true);
      return false;
    }

    if (userPlan?.no_of_properties_unlimited) {
      console.log('User has unlimited property access');
      return true;
    }

    const uniqueProperties = new Set(userActivities.map(a => a.property_id));
    const isExistingProperty = uniqueProperties.has(currentPropertyId);
    
    console.log(`User has accessed ${uniqueProperties.size} unique properties`);
    console.log(`Is current property already accessed? ${isExistingProperty}`);

    const propertyLimit = userPlan?.no_of_properties || 10;
    
    if (uniqueProperties.size >= propertyLimit && !isExistingProperty) {
      console.log(`Property limit (${propertyLimit}) exceeded - showing limit modal`);
      setShowLimitModal(true);
      return false;
    }
    
    return true;
  };

  const fieldMap = {
    'Commercial land/plot': ['Site Area', 'Facing', 'Price', 'Road Width'],
    'Plot/land': ['Site Area', 'Facing', 'Price', 'Road Width'],
    'Rent with duplex building': ['Property Name', 'Site Area', 'Facing', 'Price', 'No.of Floors', 'Buildup Area', 'Borewell', 'No.of Cars Parking', '1bhk Count', '2bhk Count', 'Duplex Bedrooms', 'Lift', 'Road Width'],
    'Duplex house': ['Property Name', 'Site Area', 'Facing', 'Price', 'No.of Floors', 'Buildup Area', 'Borewell', 'No.of Cars Parking', 'Duplex Bedrooms', 'Lift', 'Road Width'],
    'Rental building': ['Property Name', 'Site Area', 'Facing', 'Price', 'No.of Floors', 'Buildup Area', 'Borewell', 'No.of Cars Parking', '1bhk Count', '2bhk Count', '3bhk Count', 'Lift', 'Road Width'],
    'Pg-offices': ['Property Name', 'Site Area', 'Facing', 'Price', 'Rooms Count', 'Floors', 'Borewell', 'No.of Cars Parking', 'Lift', 'Road Width', 'Buildup Area'],
    'Flat': ['Property Name', 'Site Area', 'Facing', 'Price', 'No.of Bedrooms', 'No.of Cars Parking', 'Borewell', 'Lift', 'Road Width', 'Buildup Area'],
    'Villa': ['Property Name', 'Site Area', 'Facing', 'Price', 'No.of Bedrooms', 'No.of Cars Parking', 'Borewell', 'Floors', 'Lift', 'Road Width', 'Buildup Area'],
    'Commercial building': ['Property Name', 'Site Area', 'Facing', 'Price', 'Shop Count', 'No.of Cars Parking', 'Borewell', 'Floors', 'Lift', 'Road Width', 'Buildup Area'],
    'Apartment': ['Property Name', 'Site Area', 'Facing', 'Price', 'No.of Cars Parking', 'Borewell', 'House Count', '1bhk Count', '2bhk Count', '3bhk Count', '4bhk Count', 'Lift', 'Road Width', 'Buildup Area'],
    'JV/JD': ['Site Area', 'Facing', 'Price', 'Road Width'],
  };

  const images = property?.property_images && property.property_images.length > 0
    ? property.property_images.map(img => `${BASE_URL}${img.image}`)
    : [buildingImage];

const handleLocationClick = async () => {
  if (!isSubscribed) {
    setFeatureRequested("Location Access");
    setShowSubscribeModal(true);
    return;
  }

  if (!checkPropertyLimit(property.id)) {
    return;
  }

  setLoadingLocation(true); // ✅ START spinner

  const logActivity = async () => {
    try {
      const response = await fetch(`${BASE_URL}/activities/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          user_id: userId,
          property_id: property.id,
          activity_type: "Location",
          property_by: property.owner
        })
      });

      if (!response.ok) throw new Error('Failed to log location activity');

      const newActivity = await response.json();
      setUserActivities(prev => [...prev, newActivity]);
    } catch (err) {
      console.error("Error logging location activity:", err);
    }
  };

  const openLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const userLat = position.coords.latitude;
          const userLong = position.coords.longitude;

          if (property?.lat && property?.long) {
            window.open(
              `https://www.google.com/maps/dir/?api=1&origin=${userLat},${userLong}&destination=${property.lat},${property.long}`,
              '_blank'
            );
          } else if (property?.loc) {
            window.open(
              `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(property.loc)}`,
              '_blank'
            );
          }
          setLoadingLocation(false); // ✅ STOP spinner
        },
        () => {
          setLoadingLocation(false); // ✅ STOP spinner on error
        }
      );
    } else {
      setLoadingLocation(false);
    }
  };

  await logActivity();
  openLocation();
};


  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch categories first
        const categoriesRes = await axios.get(`${BASE_URL}/property-category/`);
        setCategories(categoriesRes.data);

        // Then fetch property if propertyId exists
        if (propertyId) {
          console.log('Fetching property with ID:', propertyId); // ADDED debug log
          const propertyRes = await axios.get(`${BASE_URL}/property/${propertyId}/`);
          setProperty(propertyRes.data);
        } else {
          console.error('No propertyId found in state or params'); // ADDED error handling
        }
      } catch (err) {
        console.error('Failed to fetch data:', err);
      }
    };

    fetchData();
  }, [propertyId]); // CHANGED: Now depends on the combined propertyId

  if (!property) {
    return (
      <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
        <Typography>Loading property...</Typography>
      </Box>
    );
  }

  const propertyCategory = categories.find(cat => cat.category_id == property.category_id);
  const categoryName = propertyCategory ? propertyCategory.category : property.type;

  const fieldsToDisplay = fieldMap[categoryName] || [];
  const hideBuiltUpAndFloor = [
    'commercial land/plot', 
    'plot/land',
    'jv/jd', 
  ].includes(categoryName?.trim().toLowerCase());

  const excludedDisplayFields = [
    'Site Area',
    'Facing',
    'Price',
    'Road Width',
    'No.of Floors',
    'Buildup Area'
  ];

  const propertyDetails = fieldsToDisplay.map((field) => {
    switch (field) {
      case 'Site Area':
        return { label: 'Site Area', value: `${property.site_area || 'NA'} sq ft`, icon: <CropSquareOutlinedIcon /> };
      case 'Facing':
        return { label: 'Facing', value: property.facing?.replace(/"/g, '') || 'NA', icon: <CompassCalibrationOutlinedIcon /> };
      case 'Price':
        return { label: 'Price', value: property.price ? property.price.toLocaleString('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 0 }) : 'NA', icon: <SecurityOutlinedIcon /> };
      case 'Road Width':
        return { label: 'Road Width', value: `${property.roadwidth || 'NA'} ft`, icon: <CropSquareOutlinedIcon /> };
      case 'No.of Floors':
        return { label: 'No. of Floors', value: `${property.no_of_flores || 'NA'}`, icon: <LayersOutlinedIcon /> };
      case 'Buildup Area':
        return { label: 'Buildup Area', value: `${property.buildup_area || 'NA'} sq ft`, icon: <CropSquareOutlinedIcon /> };
      case 'Borewell':
        return { label: 'Bore Well', value: property.borewell === 'Yes' ? 'Available' : property.borewell === 'No' ? 'Not Available' : 'NA', icon: <OpacityIcon /> };
      case 'No.of Cars Parking':
        return { label: 'No. of Cars Parking', value: `${property.parking || 'NA'}`, icon: <DirectionsCarIcon /> };
      case '1bhk Count':
        return { label: '1 BHK Count',  value: property._1bhk_count ? `${property._1bhk_count} No's` : 'NA',  icon: <BedIcon /> };
      case '2bhk Count':
        return { label: '2 BHK Count',  value: property._2bhk_count ? `${property._2bhk_count} No's` : 'NA',  icon: <BedIcon /> };
      case '3bhk Count':
        return { label: '3 BHK Count',  value: property._3bhk_count ? `${property._3bhk_count}  No's` : 'NA',  icon: <BedIcon /> };
      case '4bhk Count':
        return { label: '4 BHK Count',   value: property._4bhk_count ? `${property._4bhk_count}  No's` : 'NA',  icon: <BedIcon /> };
      case 'Duplex Bedrooms':
        return { label: 'Duplex Bedrooms', value: property.duplex_bedrooms || 'NA', icon: <BedIcon /> };
      case 'Lift':
        return { label: 'Lift', value: property.lift === 'Yes' ? 'Available' : property.lift === 'No' ? 'Not Available' : 'NA', icon: <ElevatorIcon /> };
      case 'House Count':
        return { label: 'House Count', value: property.house_count ?  `${property.house_count}  No's` : 'NA', icon: <HomeWorkIcon /> };
      default:
        return null;
    }})
 .filter(detail => detail !== null && !excludedDisplayFields.includes(detail.label));

  const groupedPropertyDetails = [];
  for (let i = 0; i < propertyDetails.length; i += 2) {
    groupedPropertyDetails.push(propertyDetails.slice(i, i + 2));
  }

  return (
    <Box sx={{ width: '100vw', minHeight: '100vh', backgroundColor: 'rgb(239, 231, 221)', pb: 10 }}>
      <Box sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 10,
        bgcolor: 'rgb(49, 48, 49)',
        color: 'white',
        p: 2,
        display: 'flex',
        alignItems: 'center',
      }}>
        <IconButton onClick={() => navigate(-1)} sx={{ color: 'white', mr: 1 }}>
          <ArrowBackIosNewIcon />
        </IconButton>
        <Typography variant="h6" fontWeight="bold">
          {categoryName?.replace(/"/g, '') || 'Property Type'}
        </Typography>
      </Box>

      <Box sx={{ pt: '80px', px: 2 }}>
      <Card
  sx={{
    borderRadius: '20px',
    background: 'linear-gradient(135deg, #ffffff 0%,rgb(248, 248, 248) 100%)',
    boxShadow: 5,
    overflow: 'hidden',
  }}
>
<Box
  sx={{
    width: '100%',
    height: '200px',
    overflow: 'hidden',
    borderTopLeftRadius: '20px',
    borderTopRightRadius: '20px',
    position: 'relative',

    '& .carousel-root': { height: '100% !important', width: '100% !important' },
    '& .carousel': { height: '100% !important', width: '100% !important' },
    '& .carousel-slider': { height: '100% !important', width: '100% !important' },
    '& .slider-wrapper': { height: '100% !important', width: '100% !important' },
    '& .slider': { height: '100% !important', width: '100% !important' },
    '& .slide': { height: '100% !important', minWidth: '100% !important' },
    '& .slide > div': { 
      height: '100% !important', 
      width: '100% !important',
      position: 'relative !important',  // ✅ THIS was missing — fixes blur layer
    },
  }}
>
  {images.length > 1 ? (
    <Carousel
      selectedItem={images.indexOf(selectedImage)}
      showThumbs={false}
      showArrows={false}
      autoPlay
      infiniteLoop
      interval={3000}
      showIndicators
      showStatus={false}
      swipeable
      emulateTouch
      stopOnHover
      transitionTime={600}
      useKeyboardArrows
    >
    {images.map((image, index) => (
  <Box
    key={index}
    sx={{
      width: '100%',
      height: '200px',
      position: 'relative',
      overflow: 'hidden',
      display: 'block',
    }}
  >
    {/* Blurred background */}
    <Box
      component="img"
      src={image}
      aria-hidden="true"
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%) scale(1.3)',
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        filter: 'blur(16px)',
        opacity: 0.7,
        zIndex: 0,
      }}
    />

    {/* Main image */}
    <Box
      component="img"
      src={image}
      alt="Property"
      loading="lazy"
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '100%',
        height: '100%',
        objectFit: 'contain',
        zIndex: 1,
      }}
    />

    {/* ✅ ADD THIS WATERMARK */}
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Typography
        sx={{
          textAlign: 'center',
          fontSize: '12px',
          fontWeight: 'bold',
          color: 'rgba(255, 255, 255, 0.54)',
          whiteSpace: 'nowrap',
        }}
      >
        PROPERTY PINCODER
      </Typography>
    </Box>
  </Box>
))}
    </Carousel>
  ) : (
    <Box
      sx={{
        width: '100%',
        height: '200px',
        position: 'relative',
        overflow: 'hidden',
        borderTopLeftRadius: '20px',
        borderTopRightRadius: '20px',
      }}
    >
      {/* ✅ Blurred background */}
      <Box
        component="img"
        src={images[0]}
        aria-hidden="true"
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%) scale(1.3)',
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          filter: 'blur(16px)',
          opacity: 0.7,
          zIndex: 0,
        }}
      />
      {/* ✅ Main image */}
      <Box
        component="img"
        src={images[0]}
        alt="Property"
        loading="lazy"
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          zIndex: 1,
        }}
      />
      {/* ✅ Watermark Overlay */}
<Box
  sx={{
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    pointerEvents: 'none',
    zIndex: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }}
>
  <Typography
    sx={{
      position: 'absolute',
   textAlign:'center',
      fontSize: '12px',
      fontWeight: 'bold',
      color: 'rgba(255, 255, 255, 0.54)', // 👈 transparent
      whiteSpace: 'nowrap',
    }}
  >
    PROPERTY PINCODER
  </Typography>


</Box>
    </Box>
  )}
</Box>

          {/* Thumbnail Images */}
    {/* ================= THUMBNAILS (PERCENTAGE FIX) ================= */}
<Container sx={{ mt: 3 }}>
  <Box
    sx={{
      display: 'flex',
      overflowX: 'auto',
      gap: 2,
      padding:'2%',
      pb: 1,
      '&::-webkit-scrollbar': { display: 'none' },
      scrollbarWidth: 'none',
      msOverflowStyle: 'none',
    }}
  >
    {images.map((image, index) => (
      <Box
        key={index}
        onClick={() => handleImageClick(image)}
        sx={{
          width: '30%',          // ✅ percentage
          minWidth: '30%',
          aspectRatio: '4 / 3',  // ✅ replaces height: 80px
          borderRadius: '12px',
          overflow: 'hidden',
          position: 'relative',
          cursor: 'pointer',
          boxShadow:
            selectedImage === image
              ? '0px 4px 20px rgba(0,0,0,0.3)'
              : '0px 2px 8px rgba(0,0,0,0.1)',
          transform: selectedImage === image ? 'scale(1.02)' : 'scale(1)',
          transition: 'all 0.4s ease',
          border:
            selectedImage === image
              ? '2px solid #1976d2'
              : '2px solid transparent',
          flexShrink: 0,
          '&:hover': {
            transform: 'scale(1.05)',
            boxShadow: '0px 6px 18px rgba(0,0,0,0.2)',
          },
        }}
      >
        <Box
          component="img"
          src={image}
          alt={`Thumbnail ${index + 1}`}
          loading="lazy"
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
      </Box>
    ))}
  </Box>
</Container>


          <CardContent>
            <Typography fontWeight="bold" fontSize="18px">
                                 {categoryName?.replace(/"/g, '')} - {property.property_name || 'Property Type'} - PROP{property.id || propertyId}
            </Typography>
 <Grid
  item
  sx={{
    display: 'flex',
    flexDirection: 'column',
    mt: 1,
    gap: 0.5,
    mb:0.3
  }}
>
  {/* TOP ROW */}
<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' ,mb:'5px'}}>
  
  {/* LEFT: Call Icon */}
   <Box sx={{ width: 32, display: 'flex', alignItems: 'center' }}>
    <Tooltip title="Copy mobile number">
        <IconButton
              size="small"
              onClick={() => handleCopyMobile(property.mobile_no)}
              sx={{
                color: 'success.main',
                p: 0, // remove extra padding
                 gap: '4px',
                '&:hover': { backgroundColor: 'rgba(76, 175, 80, 0.1)' },
              }}
            >
              <CallIcon sx={{ fontSize: '19px' }} />
               <span style={{ fontSize: '14px' }}>Call</span>
            </IconButton>
    </Tooltip>
  </Box>


<Typography
  fontWeight="bold"
  fontSize="12px"
  color="rgb(240, 65, 30)"
  sx={{ whiteSpace: 'nowrap', display: 'flex', alignItems: 'center' }}
>
  {property.price ? (
    <>
      <span style={{ fontSize: '15px', marginRight: '2px' }}>₹</span>

      <span>
        {property.price.toLocaleString('en-IN')}
      </span>
    </>
  ) : (
    'NA'
  )}
</Typography>
</Box>

{/* BOTTOM ROW */}
<Typography
  variant="caption"
  color="text.secondary"
  sx={{
    display: 'flex',
    alignItems: 'flex-start',
    gap: 0.2,
  }}
>
  <Box sx={{ width: 32, display: 'flex', alignItems: 'flex-start' }}>
    {loadingLocation ? (
      <CircularProgress size={14} />
    ) : (
      <LocationOnIcon
        onClick={handleLocationClick}
        sx={{
          fontSize: '18px',
          color: 'primary.main',
          cursor: 'pointer',
        }}
      />
    )}
  </Box>

  <span>
    {property.location || 'Not Specified'}
  </span>
</Typography>



</Grid>

  <Box sx={{
              display: 'flex',
              justifyContent: 'space-between',
              bgcolor: '#ede7f6',
              borderRadius: 2,
              p: 2,
              mb: 2,
            }}>
  <Box sx={{ textAlign: 'center', flex: 1 }}>
  <Typography fontWeight="bold" color="primary">
    {property.site_area || property.max_acres
      ? (() => {
          const value = property.site_area || property.max_acres;
          const unitRaw = property.units || '';
          const unit = unitRaw.toLowerCase();

          // Acres & Gunta → show as it is
          if (['acre', 'acres', 'gunta', 'guntas'].includes(unit)) {
            return `${value} ${unitRaw}`;
          }

          // Other units → add "Sq" before unit
          return `${value} Sq ${unitRaw || 'ft'}`;
        })()
      : 'NA'}
  </Typography>

  <Typography variant="caption" color="text.secondary">
    Site Area
  </Typography>
</Box>
              <Box sx={{ textAlign: 'center', flex: 1 }}>
                <Typography fontWeight="bold" color="primary">
                  {property.roadwidth || 'NA'} ft
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Road Width
                </Typography>
              </Box>
              <Box sx={{ textAlign: 'center', flex: 1 }}>
                <Typography fontWeight="bold" color="primary">
                  {property.facing?.replace(/"/g, '') || 'NA'}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Facing
                </Typography>
              </Box>
            </Box>

            <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
              <Typography variant="subtitle1" fontWeight="bold">
                Overview:
              </Typography>
              <Typography variant="subtitle1" fontWeight="bold">
                Posted: <span style={{ fontWeight: 'normal' }}>{property.posted_by || ''}</span>
              </Typography>
            </Box>

            <Box
              sx={{
                border: '2px solid #424242',
                borderRadius: 2,
                overflow: 'hidden',
              }}
            >
              {groupedPropertyDetails.map((row, rowIndex) => (
                <Box key={rowIndex} sx={{ display: 'flex', width: '100%' }}>
                  {row.map((item, colIndex) => (
                    <Box
                      key={colIndex}
                      sx={{
                        flex: '0 0 50%',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        p: 1.5,
                        boxSizing: 'border-box',
                        borderRight: colIndex === 0 ? '1px solid #9e9e9e' : 'none',
                        borderBottom: '1px solid #9e9e9e',
                        minWidth: 0,
                      }}
                    >
                      <Box
                        sx={{
                          color: 'rgb(50, 47, 52)',
                          flexShrink: 0,
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        {item.icon}
                      </Box>
                      <Box sx={{ minWidth: 0, overflow: 'hidden' }}>
                        <Typography
                          fontWeight={500}
                          fontSize="0.875rem"
                          sx={{
                            whiteSpace: 'normal',
                            wordBreak: 'break-word',
                            lineHeight: 1.3,
                          }}
                        >
                          {item.value}
                        </Typography>
                        <Typography
                          variant="caption"
                          color="text.secondary"
                          fontSize="0.75rem"
                          sx={{
                            whiteSpace: 'normal',
                            wordBreak: 'break-word',
                            lineHeight: 1.3,
                          }}
                        >
                          {item.label}
                        </Typography>
                      </Box>
                    </Box>
                  ))}
                  {row.length === 1 && (
                    <Box sx={{ flex: '0 0 50%', borderBottom: '1px solid #9e9e9e' }} />
                  )}
                </Box>
              ))}
            </Box>

            {!hideBuiltUpAndFloor && (
              <Box sx={{ mt: 3, borderTop: '1px dashed #d1c4e9', pt: 2 }}>
                {[
                  ['Built Up Area', `${property.buildup_area || 'NA'} Sq.ft`, <CropSquareOutlinedIcon />],
                  ['Facing', property.facing?.replace(/"/g, '') || 'NA', <CompassCalibrationOutlinedIcon />],
                  ['Floor', `${property.no_of_flores || 'NA'}`, <LayersOutlinedIcon />],
                ].map(([label, value, icon], i) => (
                  <Box
                    key={i}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      mb: i !== 3 ? 1.5 : 0,
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', color: 'rgb(52, 50, 53)' }}>
                      {icon}
                      <Typography fontSize={14} sx={{ ml: 1 }} color="text.primary">
                        {label}
                      </Typography>
                    </Box>
                    <Typography fontWeight={500} color="text.primary" fontSize={14}>
                      {value}
                    </Typography>
                  </Box>
                ))}
              </Box>
            )}

<Box
  sx={{
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    mt: 2
  }}
>
  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
    <CropSquareOutlinedIcon sx={{ color: "#444" }} />
    <Typography sx={{ fontSize: "0.9rem" }}>
      Length*Width
    </Typography>
  </Box>
 <Typography sx={{ fontSize: "0.9rem", fontWeight: 500 }}>
  {property.length && property.width
    ? (() => {
        const unitRaw = property.units || "";
        const unit = unitRaw.toLowerCase();

        // Acres / Gunta → as it is
        if (['acre', 'acres', 'gunta', 'guntas'].includes(unit)) {
          return `${property.length} * ${property.width} ${unitRaw}`;
        }

        // Others → add Sq before unit
        return `${property.length} * ${property.width} Sq ${unitRaw || 'ft'}`;
      })()
    : "NA"}
</Typography>
</Box>

<Box
  sx={{
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    mt: 2
  }}
>
  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
    <SecurityOutlinedIcon sx={{ color: "#444" }} />
    <Typography sx={{ fontSize: "0.9rem" }}>
      Average Price
    </Typography>
  </Box>
<Typography sx={{ fontSize: "0.9rem", fontWeight: 500 }}>
  {property.price
    ? (() => {
        let area = 0;

        // ✅ Commercial buildings / apartments
        if (property.buildup_area) {
          area = parseFloat(property.buildup_area);

          const floors = parseInt(
            property.no_of_flores || property.floor || 0
          );

          // Multiply by floors only if positive
          if (floors > 0) {
            area = area * floors;
          }
        }
        // ✅ Land properties
        else if (property.site_area || property.max_acres) {
          area = parseFloat(
            property.site_area || property.max_acres
          );
        }

        if (!area || area <= 0) return "NA";

        const avgPrice =
          parseFloat(property.price) / area;

        const unitRaw = property.units || "";
        const unit = unitRaw.toLowerCase();

        // Acres / Guntas
        if (
          ["acre", "acres", "gunta", "guntas"].includes(unit)
        ) {
          return `₹${avgPrice.toFixed(2)} / ${unitRaw}`;
        }

        const hasSq = unit.includes("sq");

        return `₹${avgPrice.toFixed(2)} / ${
          hasSq ? unitRaw : `Sq ${unitRaw || "ft"}`
        }`;
      })()
    : "NA"}
</Typography>
</Box>  
          </CardContent>
        </Card>
      </Box>

      {/* Bottom Navigation */}
      {showSubscribeModal && (
        <Box sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          zIndex: 9999,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <Paper sx={{ padding: 3, maxWidth: 300, textAlign: 'center' }}>
            <Typography variant="h6" gutterBottom>
              Subscription Required
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              Please subscribe to use the {featureRequested} feature.
            </Typography>
            <Button 
              variant="contained" 
              color="primary"
              onClick={() => setShowSubscribeModal(false)}
            >
              OK
            </Button>
          </Paper>
        </Box>
      )}

      {showLimitModal && (
        <Box sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          zIndex: 9999,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <Paper sx={{ padding: 3, maxWidth: 300, textAlign: 'center' }}>
            <Typography variant="h6" gutterBottom>
              Limit Exceeded
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              {userPlan?.no_of_properties_unlimited 
                ? "You have unlimited access to properties."
                : `You've reached your limit of ${userPlan?.no_of_properties || 10} properties. 
                   Please upgrade your subscription plan for more.`
              }
            </Typography>
            <Button 
              variant="contained" 
              color="primary"
              onClick={() => setShowLimitModal(false)}
            >
              OK
            </Button>
          </Paper>
        </Box>
      )}
      
            
      {showSuccess && (
        <CopySuccessAlert
          message={alertMessage}
          onClose={() => {
            setShowSuccess(false);
            setAlertMessage(""); // Clear message when closing
          }}
        />
      )}
      
      {showFailure && (
        <CopyFailureAlert
          message={alertMessage}
          onClose={() => {
            console.log("Closing failure alert");
            setShowFailure(false);
            setAlertMessage("");
          }}
        />
      )}
      <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }} elevation={3}>
        <CustomBottomNav />
      </Paper>
    </Box>
  );
};

export default NewBuildingsDescription;